
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-f5d784e4\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/Users/max/Downloads/donauhof-src/node_modules/bourbon-neat/core\"],\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Co-Working.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Co-Working.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f5d784e4\"}!../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Co-Working.vue"),
  /* scopeId */
  "data-v-f5d784e4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Co-Working.vue
// module id = 286
// module chunks = 1